import { Injectable } from '@angular/core';
import { Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { tokenNotExpired } from 'angular2-jwt';

@Injectable()
export class SystemRequestService extends WebService {
  public getSystemsRequest(page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    if (page !== null && page !== undefined)
      params.append('_page', String(page));
    else
      params.append('_page', '1');

    if (per_page !== null && per_page !== undefined)
      params.append('_limit', String(per_page));
    else
      params.append('_limit', '10');

    if (sort !== null && sort !== undefined)
      params.append('_sort', String(sort));

    if (query !== null && query !== undefined && query !== '')
      params.append('_q', String(query));

    if (filters !== null && filters !== undefined && filters.length > 0) {
      filters.forEach(element => {
        params.append(element.key, String(element.value));
      });
    }

    // params.append('_with', String('one_answer_info'));

    const options = new RequestOptions({search: params, headers: this.headers});

    return this.http.get( `${this.apiUrl}/systems-request?${params}`, options);
  }
  
  // public newSystemsRequest(body: Object): Observable<Response> {
  //   return this.http.post( `${this.apiUrl}/systems-request`, JSON.stringify(body) , { headers: this.headers } );
  // }
  public newSystemsRequest(formData: FormData): Observable<Response> {
    var headers: Headers = new Headers();
    if (tokenNotExpired()) {
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
    }
    var options = new RequestOptions({ headers: headers });
    
    return this.http.post( `${this.apiUrl}/systems-request`, formData , options );
  }
  
  public updateSystemsRequest(id: number, formData: FormData): Observable<Response> {
    var headers: Headers = new Headers();
    if (tokenNotExpired()) {
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
    }
    var options = new RequestOptions({ headers: headers });
    
    return this.http.post( `${this.apiUrl}/systems-request/${id}`, formData , options );
    // return this.http.patch( `${this.apiUrl}/systems-request/${id}`, formData , options );
  }
  
  public deleteSystemsRequest(id: number): Observable<Response> {
    return this.http.delete( `${this.apiUrl}/systems-request/${id}`, { headers: this.headers } );
  }
  
  // public infoSystemsRequest(id: number): Observable<Response> {
  //   return this.http.get( `${this.apiUrl}/systems-request/${id}`,  { headers: this.headers } );
  // }
  
  public infoSystemsRequest(id: number): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    params.append('_with', String('system_request_answers,documents_system_request'));

    const options = new RequestOptions({search: params, headers: this.headers});

    return this.http.get( `${this.apiUrl}/systems-request/${id}?${params}`, options);
  }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/system-request/system-request.service.ts